var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"500"},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('v-card',[_c('LoginForm',{on:{"success":function($event){return _vm.$emit('success')}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }